/**
 * Changement du mode de départ d'un direct qui part bientôt.
 *
 * Le 01/10/2026, la suite d'un direct a été passée de « Automatique » à
 * « Manuel » moins de 2 min avant son départ : le moteur l'avait déjà
 * préchargée en automatique, a dû basculer sur la boucle d'attente au dernier
 * moment, et la boucle était introuvable. Le changement reste permis — c'est
 * parfois le bon réflexe — mais la régie le signale et demande confirmation.
 */

/** En deçà de ce délai avant le départ, changer le mode de départ est risqué. */
export const LIVE_START_MODE_CHANGE_RISK_MS = 2 * 60 * 1000

export function isRiskyLiveStartModeChange(input: {
  itemType:      string
  status:        string
  previousMode:  string | null | undefined
  nextMode:      string
  startMs:       number
  nowMs:         number
}): boolean {
  if (input.itemType !== 'LIVE') return false
  if ((input.previousMode ?? 'AUTO') === input.nextMode) return false
  if (input.status === 'DONE' || input.status === 'SKIPPED' || input.status === 'ON_AIR') return false
  const untilStart = input.startMs - input.nowMs
  // Déjà parti en retard ou dans les 2 min : le moteur a préchargé le direct.
  return untilStart < LIVE_START_MODE_CHANGE_RISK_MS && untilStart > -LIVE_START_MODE_CHANGE_RISK_MS
}

export const RISKY_LIVE_START_MODE_MESSAGE =
  'Ce direct part dans moins de 2 minutes et le moteur l’a déjà préparé. '
  + 'Changer son mode de départ maintenant peut le faire échouer à l’antenne.'
